module.exports = __webpack_public_path__ + "img/market2x.png?eae0c1c26afe6efac6b3ae82bc9b5202";